import validate from "/root/workspace/ldshop_vest/node_modules/.pnpm/nuxt@3.14.159_@types+node@20.14.11_eslint@8.57.0_ioredis@5.6.0_rollup@4.26.0_sass@1.77.6_typescript@5.5.3_vite@5.4.11/node_modules/nuxt/dist/pages/runtime/validate.js";
import locale_45by_45browser_45global from "/root/workspace/ldshop_vest/layers/base/middleware/locale-by-browser.global.ts";
import manifest_45route_45rule from "/root/workspace/ldshop_vest/node_modules/.pnpm/nuxt@3.14.159_@types+node@20.14.11_eslint@8.57.0_ioredis@5.6.0_rollup@4.26.0_sass@1.77.6_typescript@5.5.3_vite@5.4.11/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  locale_45by_45browser_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-seo": () => import("/root/workspace/ldshop_vest/layers/base/middleware/check-seo.ts"),
  "login-by-token": () => import("/root/workspace/ldshop_vest/layers/base/middleware/login-by-token.ts")
}